var map = {
	"./footer.de-CH.json": 994,
	"./footer.de-DE.json": 995,
	"./footer.en-CA.json": 996,
	"./footer.en-GB.json": 997,
	"./footer.en-IN.json": 998,
	"./footer.en-ME.json": 999,
	"./footer.en-US.json": 1000,
	"./footer.es-EM.json": 1001,
	"./footer.es-ES.json": 1002,
	"./footer.fr-BE.json": 1003,
	"./footer.fr-CA.json": 1004,
	"./footer.fr-CH.json": 1005,
	"./footer.nl-BE.json": 1006,
	"./footer.nl-NL.json": 1007,
	"./footer.pl-PL.json": 1008,
	"./footer.pt-BR.json": 1009
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 993;